import React from 'react';
import { Link } from 'react-router-dom';
import './Products.css';
import Breadcrumb_comp from '../common_component/breadcrumb-comp/Breadcrumb_comp';
import Our_product_card from '../home/our_product/our_product_card/Our_product_card';
import productData from './productData/ProductData';

function Products() {
  return (
    <section className='Products'>
      <div className="container">
        <Breadcrumb_comp
          breadcrumbs={[
            { label: "Home", link: "/", isActive: false },
            { label: "Product", link: "", isActive: true },
          ]}
        />

        <div className="row justify-content-center">
          {productData.map((product, i) => (
            <div key={i} className="col-xl-3 col-md-4 col-sm-6 col-12 mb-5">
              <Link to={`/products/${product.id}`} >
                <Our_product_card
                  imgSrc={product.cardImage}
                  title={product.title}
                  subTitle={product.subTitle}
                />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Products;
